import { CardBigNumberProps } from "./cardBigNumberType";
import * as Css from "./style"

export default function CardBigNumber(props: CardBigNumberProps){
    return(
        <Css.ContentBigNumber>
            <p>{props.title}</p>
            <span>{props.quant}</span>
        </Css.ContentBigNumber>
    )
}